export default __webpack_public_path__ + "static/media/locaweb-horizontal.1f0486dd.svg";